"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeCards = void 0;
var React = require("react");
exports.placeCards = function (props) {
    if (!props.topPlaces || !props.topPlaces.length)
        return null;
    var renderTopPlace = function (topPlace, i) {
        return (React.createElement("a", { key: i, href: topPlace.link, className: "c-place-card" },
            React.createElement("div", { className: "c-place-card__img" },
                React.createElement("img", { "data-src": topPlace.image, alt: topPlace.name })),
            React.createElement("div", { className: "c-place-card__info" },
                React.createElement("div", { className: "c-place-card__title" }, topPlace.name),
                React.createElement("div", { className: "c-place-card__caption" }, topPlace.caption),
                React.createElement("div", { className: "c-place-card__type c-place-card__type--building" }))));
    };
    return (React.createElement("div", { id: "place-topplace", className: "l-container l-container--lr l-pad--2" },
        React.createElement("div", { className: "l-container__main" },
            React.createElement("h2", { className: "c-building__place-head" },
                props.nameMain,
                " - ",
                props.t.topPlace),
            React.createElement("div", { className: "c-place-card__container" }, props.topPlaces.map(renderTopPlace)))));
};
